import { AppTFunction } from '@retail/app/i18n';
import * as yup from 'yup';

export const editSalesPriceSchema = (t: AppTFunction) =>
  yup.object({
    fromDate: yup.date().required(t('calculus.error.requiredField')),
    salesPrice: yup
      .number()
      .typeError(t('calculus.error.mustBeNumberOver0'))
      .transform((_, value: string | null) =>
        value ? Number((value + '').replace(',', '.')) : undefined
      )
      .positive(t('calculus.error.mustBeNumberOver0'))
      .required(t('calculus.error.requiredField')),
  });

export type EditSalesPriceSchema = yup.InferType<ReturnType<typeof editSalesPriceSchema>>;
